module.exports = __webpack_public_path__ + "img/member_lip1.53c0faea.png";